import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { Button } from '@mui/material';

import staticText from '../../../../../../localization/Application/Billing/billing';

const PlanButton = ({
  buttonTexts,
  columnPlanName,
  emailVerifiedAt,
  setCurrentModal,
  userPlanName,
  isCurrentPlanLegacy,
}) => {
  const buttonProps = {
    variant: 'outlined',
  };

  let buttonText = 'Current';

  const userPlan = userPlanName.toLowerCase();
  const columnPlan = columnPlanName.toLowerCase();
  const isUserOnColumnPlan = userPlan === columnPlan && !isCurrentPlanLegacy;

  // disable button if user is on the same plan
  if (isUserOnColumnPlan) {
    buttonProps.disabled = true;
    buttonProps.current = true;
    buttonText = buttonTexts.current;

  // if user's current plan is not free, the free plan button should show downgrade
  } else if (columnPlan === staticText.freePlanName) {
    buttonProps.onClick = () => setCurrentModal('downgradeFree');
    buttonText = buttonTexts.downgrade;
  } else if (columnPlan === staticText.buildPlanName) {
    // We can remove business logic when there are no more Business (legacy) plans
    if (
      userPlan === staticText.scalePlanName ||
      userPlan === staticText.businessPlanName
    ) {
      buttonProps.onClick = () => setCurrentModal('downgradeBuild');
      buttonText = buttonTexts.downgrade;
    } else if (!emailVerifiedAt) {
      buttonProps.onClick = () => setCurrentModal('verifyEmail');
      buttonText = buttonTexts.upgrade;
    } else {
      buttonProps.onClick = () => setCurrentModal({ name: 'businessTax', params: [columnPlan] });

      buttonText = buttonTexts.upgrade;
    }
  } else if (userPlan === staticText.freePlanName &&
    columnPlanName === staticText.salesLedPlanName) {
    buttonProps.onClick = () => setCurrentModal('hubspotContact');
    buttonText = buttonTexts.contactUs;
  } else {
    buttonProps.onClick = () => setCurrentModal('hubspotContact');

    buttonText = buttonTexts.contactUs;
  }

  return (
    <div>
      <Button
        variant="outlined"
        {...buttonProps}
        sx={{
          width: '100%',
          fontSize: '1.125rem',
        }}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PlanButton;

PlanButton.propTypes = {
  buttonTexts: shape({
    contactUs: string.isRequired,
    downgrade: string.isRequired,
    upgrade: string.isRequired,
    current: string.isRequired,
  }).isRequired,
  columnPlanName: string.isRequired,
  emailVerifiedAt: string,
  setCurrentModal: func.isRequired,
  userPlanName: string.isRequired,
  isCurrentPlanLegacy: bool.isRequired,
};

PlanButton.defaultProps = {
  emailVerifiedAt: null,
};
